import apiService from '../../../repositories/apiService';

export default {
    getMeditations({ rootGetters, commit, state }) {
        return new Promise((resolve, reject) => {
            apiService.get(
                '/meditations',
                {
                    headers: {
                        Authorization: rootGetters.token,
                    },
                },
            )
                .then((response) => {
                    commit('setMeditations', response.data);
                })
                .catch((error) => {
                    commit('setError', error);
                });
        });
    },
    getMeditationById(state, payload) {
        return new Promise((resolve, reject) => {
            apiService.defaults.headers.common.Authorization = state.rootState.token;
            apiService.get(
                `/meditations/${payload.meditationId}`
            )
                .then((response) => {
                    state.commit('setMeditation', response.data);
                })
                .catch((error) => {
                    state.commit('setError', error);
                });
        });
    },
};
